/*
 * Media queries
 *
 * Apply conditional styles based on device width, e.g.:
 * ${mq.palm} {
 *   color: red,
 * },
 * ${mq.desk} {
 *   display: flex,
 * },
 *
 */

const lapStart = 481;
const deskStart = 1024;
const deskWideStart = 1200;
const palmEnd = lapStart - 1;
const lapEnd = deskStart - 1;

const mq = {
  palm: `@media only screen and (max-width: ${palmEnd}px)`,
  lap: `@media only screen and (min-width: ${lapStart}px) and (max-width: ${lapEnd}px)`,
  lapAndUp: `@media only screen and (min-width: ${lapStart}px)`,
  portable: `@media only screen and (max-width: ${lapEnd}px)`,
  desk: `@media only screen and (min-width: ${deskStart}px)`,
  deskWide: `@media only screen and (min-width: ${deskWideStart}px)`
};

export default mq;
